import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loading-button',
  imports:  [CommonModule, TranslateModule],
  standalone: true,
  template: `
        <button
        class="btn"
        [ngClass]="btnClass"
        [disabled]="isDisabled"
        type="button"
        (click)="onClick()">

        <span
            *ngIf="loading"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true">
        </span>

        {{ label |translate }}
        </button>
    `
})
export class LoadingButtonComponent {
  /** Text hiển thị trên nút */
  @Input() label: string = '' ;

  /** Kiểm soát trạng thái loading */
  @Input() loading: boolean = false;

  /** Class Bootstrap cho button (vd: btn-primary, btn-danger) */
  @Input() btnClass: string = '';

  /** Disable khi loading */
  @Input() disableOnLoading: boolean = true;

  /** Event khi click */
  @Output() clicked = new EventEmitter<void>();

  get isDisabled(): boolean {
    return this.disableOnLoading && this.loading;
  }

  onClick() {
    if (!this.isDisabled) {
      this.clicked.emit();
    }
  }
}
